import { render, staticRenderFns } from "./LLPSales.vue?vue&type=template&id=c0109636&scoped=true"
import script from "./LLPSales.vue?vue&type=script&lang=js"
export * from "./LLPSales.vue?vue&type=script&lang=js"
import style0 from "./LLPSales.vue?vue&type=style&index=0&id=c0109636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0109636",
  null
  
)

export default component.exports